import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from 'src/app/_core/_guards/auth.guard';
import { LeadMainComponent } from './components/lead-main/lead-main.component';

const crmRoutes: Routes = [
  {
    path: '',
    component: LeadMainComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: ':activeTab',
    component: LeadMainComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(crmRoutes)],
  exports: [RouterModule]
})
export class CrmRoutingModule {}
